// extracted by mini-css-extract-plugin
module.exports = {"whiteColor":"#fff","borderColor":"#e5e5e5","tooltip":"Tooltip_tooltip__1K7qB","open":"Tooltip_open__20_TW","trigger":"Tooltip_trigger__2omnn"};